import { connect } from "react-redux";
import { withRouter, Prompt } from "react-router-dom";
import React from "react";
import { Formik } from "formik";
import { editEndpointList, deleteEndpointList, patchEndpointRecord } from "../actions/endpoints";
import {
	fetchEndpointIfNeeded as ftch,
	FetchEndpointListById,
} from "../actions/fetch";
import { newUser } from "../actions/auth";
import JSONForm from "./utilities/JSONForm";
import FormButtonPanel from "./utilities/FormButtonPanel";
import ReferenceDropdown from "./utilities/ReferenceDropdown";
import QueueDropdown from "./utilities/QueueDropdown";
import { CSSTransition } from "react-transition-group";
import Statuspick from "./statuspick";
import { showMessage } from "../actions/messageBox";
import { setLoader } from "../actions/loader";
import NavItem from "./utilities/NavItem";
import NavContent from "./utilities/NavContent";
import JsonViewer from "./utilities/tabs/jsonViewer";
import Datepick from "./datepick";
import Timepick from './timepick'
import moment from "moment";
import "moment-timezone";
import sidebars from "../config";
import { closeMessage } from "../actions/messageBox";
import JsonTableViewer from "./utilities/tabs/jsontable";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ReactJson from 'react-json-view';

import { EYM_TKN, EYM_TKN_OBJ, REST_API } from ".././actions/constants";
import { encodeQuery } from "../js/helpers"

let getFetched = {};

const EndpointForm = ({
	isLoading,
	list,
	lid,
	dispatch,
	endpointId,
	endpointName,
	accessToken,
	history,
	location,
	endpoints,
	isFetching,
	formType,
	parentUrl,
	formSchema,
	isUserAdmin,
	readOnly,
	deleteok

	// showBtnupdateEndpoint
}) => {

	if (!list && getFetched) {
		list = getFetched;
	}

	// Local scope constants.
	const DEL_MESS =
		"Deleting this record cannot be undone, are you sure you want to proceed?";

	// Initialize an empty object
	let objProp = {};

	// Initial values
	let initVal = Object.assign({}, list, objProp);

	// let TEST_API = "http://dev-svc.excelym.com/api/v1"
	// let REST_API = "http://dev-api.excelym.com/api/v1"

	const token = window.localStorage.getItem(`${EYM_TKN}`);

	let getAuditList;
	let getUserList;
	let getConnectionList;
	let getProviderList;
	let getDatasourceList;
	let getDatasourcemappingList;
	let getScheduleList;
	let getReleaseNoteList;
	let getJobLogList;

	for (let n in endpoints) {
		if (endpoints[n].name === "audits") {
			getAuditList = endpoints[n].list;
		} else if (endpoints[n].name === "users") {
			getUserList = endpoints[n].list;
		} else if (endpoints[n].name === "providers") {
			getProviderList = endpoints[n].list;
		} else if (endpoints[n].name === "connections") {
			getConnectionList = endpoints[n].list;
		} else if (endpoints[n].name === "datasources") {
			getDatasourceList = endpoints[n].list;
		} else if (endpoints[n].name === "datasourcemappings") {
			getDatasourcemappingList = endpoints[n].list;
		} else if (endpoints[n].name === "schedules") {
			getScheduleList = endpoints[n].list;
		} else if (endpoints[n].name === "releasenotes") {
			getReleaseNoteList = endpoints[n].list;
		} else if (endpoints[n].name === "joblogs") {
			getJobLogList = endpoints[n].list;
		}
	}

	// Force these fields to be plaintext
	let forcePlainText = ["ref_id", "target_id"];

	let requiredFields = [
		"name",
		"description",
		"connection_id",
		"provider_id",
	];
	if (endpointName === "frequencies") {
		requiredFields.push("code");
	}
	if (endpointName === "users") {
		requiredFields.push("username");
		requiredFields.push("email");
		requiredFields.push("password");
	}
	if (endpointName === "schedules") {
		requiredFields.push("task_id");
		requiredFields.push("frequency_id");
	}

	try {
		// console.log(showBtn)
		for (let field in initVal) {
			if (initVal[field] && typeof initVal[field] === "string") {
				if (moment(initVal[field], "HH:mm:ss", true).isValid()) {
				} else if(
					field == "start_date" || 
					field == "end_date"
				) {

					initVal[field] = moment.utc(initVal[field]).format("YYYY-MM-DD HH:mm:ss")					
				} else if (
					moment(
						initVal[field],
						[
							"ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]",
							"ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(Coordinated Universal Time)]",
						],
						true
					).isValid()
				) {
					initVal[field] = moment(
						initVal[field],
						[
							"ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(UTC)]",
							"ddd MMM DD YYYY HH:mm:ss [GMT]ZZ [(Coordinated Universal Time)]",
						],
						true
					).format("YYYY-MM-DD HH:mm:ss");
				}
			}
		}
	}  catch(e) {

        console.log('endpointForm Error: ', e)
    }

	return (
		<CSSTransition in={true} appear={true} timeout={500} classNames="fade">
			{list == null || list == 0 ? (
				<div className="spinner-overlay">
					<i class="fa fa-spinner fa-spin"></i>
				</div>
			) : (
				<div id="working-area-content">
					<div className="">
						{list && Object.keys(list).length && (
							<Formik
								initialValues={initVal}
								validate={(values) => {
									let errors = {};
									let nameRestriction = /^[a-zA-Z0-9-_]+$/;
									let allowSpaces = /^[a-zA-Z0-9-_ ]+$/;
									let found;

									if (
										values.hasOwnProperty("name") &&
										!values.name
									) {
										errors.name = "This field is required";
									} else if (
										values.hasOwnProperty("name") &&
										!nameRestriction.test(values.name) &&
										endpointName !== "frequencies"
									) {
										errors.name =
											"Special characters and spaces not allowed";
									} else if (
										endpointName === "frequencies" &&
										!allowSpaces.test(values.name)
									) {
										errors.name =
											"Special characters not allowed";
									} else if (
										values.hasOwnProperty("version") &&
										endpointName === "releasenotes"
									) {
										found = getReleaseNoteList.some(
											(grl) =>
												grl.version ===
													values.version &&
												formType === "new"
										);

										if (found) {
											errors.version =
												"Version name already existed";
										}
									}

									for (
										let i = 0;
										i < requiredFields.length;
										i++
									) {
										if (
											values.hasOwnProperty(
												requiredFields[i]
											) &&
											!values[requiredFields[i]]
										) {
											errors[requiredFields[i]] =
												"This field is required";
										}
									}
									return errors;
								}}
								onSubmit={(values) => {
									let url = window.location.origin;
									//Convert User name to userid upon submit
									let userEndpoint = endpoints.find(
										(userEndP) => userEndP.name === "users"
									);

									let UpdateUserId = userEndpoint.list.find(
										(usId) =>
											usId.username === values.updated_by
									);
									let CreateUserId = userEndpoint.list.find(
										(cuId) =>
											cuId.username === values.created_by
									);

									let getUpdateUserId =
										UpdateUserId && UpdateUserId.id;
									let getCreateUserId =
										CreateUserId && CreateUserId.id;

									values.updated_by = getUpdateUserId;
									values.created_by = getCreateUserId;

									let initData = {};
									let data = Object.assign(
										{},
										values,
										initData
									);
									let httpVerb =
										formType === "edit" ? "PATCH" : "PUT";
									dispatch(
										editEndpointList(
											endpointId,
											endpointName,
											accessToken,
											data,
											httpVerb
										)
									).then((resObj) => {
										if (resObj.response.ok) {
											let message = values.hasOwnProperty(
												"name"
											)
												? `${values.name} successfully saved`
												: "Successfully saved";
											dispatch(
												showMessage({
													type: "success",
													title: "Success",
													message: message,
													onClick: () => {

														if (document.location.pathname.indexOf("/users") != -1) {

															document.location = "/users";
														} else {

															history.push(parentUrl);
														}
													},
												})
											);
											if (
												endpointName === "users" &&
												formType == "new"
											) {
												dispatch(
													newUser(
														accessToken,
														values.email,
														values.username,
														values.password,
														url
													)
												);
											}
											dispatch(ftch(15, true));

											//if (formType === 'new') {
											//    resObj.json.then(created => {
											//        history.push(parentUrl + '/edit/' + created.id)
											//    })
											//}
										}
									});
								}}
								render={({
									handleSubmit,
									handleChange,
									setFieldValue,
									values,
									errors,
								}) => {

									const onHandleSubmit = (e) => {

										e.preventDefault(); 

										let etval = document.getElementById("schedule.end_time_value")
									    
									    if (etval && etval.classList.contains("is-invalid")) {

									      e.preventDefault();
									    } else {

									    	handleSubmit()
									    }
									}

									const modules = {
										toolbar: [
											[
												{
													header: [
														1,
														2,
														3,
														4,
														5,
														false,
													],
												},
											],
											[
												"bold",
												"italic",
												"underline",
												"strike",
												"blockquote",
											],
											[
												{ list: "ordered" },
												{ list: "bullet" },
												{ indent: "-1" },
												{ indent: "+1" },
											],
										],
									};

									let fields = [];
									let jsonFormTabList = [];
									let jsonFormFields = [];
									let additionalTabs = ["Audit"];
									let additionalJobqueueTabs = ["Details"];
									let jsonFormCounter = 0;
									let statusField = null;
									let formBtnPanel = null;
									let keycount = 0;

									if (
										endpointName === "schedules" &&
										isUserAdmin
									) {
										let filterAuditList = getAuditList.filter(
											(fal) =>
												fal.document_id === list.id &&
												fal.document_type === "schedule"
										);

										let sortFilteredAuditList = filterAuditList.sort(
											function (a, b) {
												return (
													new Date(b.updated_at) -
													new Date(a.updated_at)
												);
											}
										);

										for (let a in additionalTabs) {
											jsonFormTabList.push(
												<NavItem
													active={
														jsonFormCounter === 0
															? "active"
															: ""
													}
													key={`${additionalTabs[a]}-${keycount}-tabheader`}
													name={`${additionalTabs[a]}-${keycount}`}
													value={additionalTabs[a]}
													selected={true}
												/>
											);

											jsonFormFields.push(
												<NavContent
													key={`${additionalTabs[a]}-${keycount}-tabcontent`}
													id={`${additionalTabs[a]}-${keycount}`}
													active={
														jsonFormCounter === 0
															? "show active"
															: ""
													}
													content={
														<div className="p-2">
															<JsonTableViewer
																value={
																	sortFilteredAuditList
																}
																user={
																	getUserList
																}
															/>
														</div>
													}
												/>
											);
										}
									} else if (endpointName === "jobqueues") {
										// console.log("list here", list)

										// console.log("getJobLogList",getJobLogList)

										let jobqueueList = list;
										let skipJobqueueField = false;
										let addJobqueueField;
										let filterJobLogList;

										let jobqueueDetailsContent = [];

										// console.log("beforeArray",jobqueueList)

										// console.log(typeof jobqueueList)

										// let jobqueuueListArray = Object.entries(jobqueueList)
										// console.log("beforejobqueuueListArray",jobqueuueListArray)
										// jobqueuueListArray = arrayMove(jobqueuueListArray,3,9)
										// console.log("beforejobqueuueListArray",jobqueuueListArray)

										// const obj = Object.fromEntries(jobqueuueListArray);
										// console.log("obj",obj)

										// // let newJobqueueList = Object.assign({},obj)
										// // console.log("newJobqueueList",newJobqueueList)
										// // console.log("afterArray",jobqueueList)

										// // let modifiedJobqueueList =

										let getMemo;

										for (let c in jobqueueList) {
											if (c == "memo") {
												getMemo = values[c];
											}
										}

										// console.log("getMemo",getMemo)

										for (let b in jobqueueList) {
											let forLabel = titleCase(b).trim();

											let getJobLogId;

											if (b === "id") {
												getJobLogId = values[b];
											}

											// console.log("getJobLogId",getJobLogId)

											if (getJobLogId) {
												// filterJobLogList  = getJobLogList.filter(gbl => gbl.job_id === 29323)
												filterJobLogList = getJobLogList.filter(
													(gbl) =>
														gbl.job_id ===
														getJobLogId
												);
												// console.log("filterJobLogList",filterJobLogList)
											}

											// console.log("filterJobLogList",filterJobLogList)

											// console.log("getJobLogId",getJobLogId)

											let jobqueueFieldType =
												formSchema.hasOwnProperty(b) &&
												formSchema[b]
													.jobqueueFieldType &&
												typeof formSchema[b]
													.jobqueueFieldType ===
													"string"
													? formSchema[b]
															.jobqueueFieldType
													: "text";

											if (
												b === "process_status" ||
												b === "process_start_at" ||
                                                b === "process_end_at" 
											) {  

                                                addJobqueueField = (
                                                    <div
                                                        key={keycount++}
                                                        className="row mb-2"
                                                        id="transform-input-type"
                                                    >
                                                        {/* <div className="col-12">
                                                        
                                                    </div> */}
                                                        <div className="col-2 text-left">
                                                            <label htmlFor={b}>
                                                                {forLabel}
                                                            </label>
                                                        </div>
                                                        <div className="col-10 text-right">
                                                            <input
                                                                className={
                                                                    "form-control" +
                                                                    (errors &&
                                                                    errors[b]
                                                                        ? " is-invalid"
                                                                        : "")
                                                                }
                                                                type={
                                                                    jobqueueFieldType
                                                                }
                                                                name={b}
                                                                id={b}
                                                                onChange={
                                                                    handleChange
                                                                }
                                                                value={
                                                                    values[
                                                                        b
                                                                    ] === null
                                                                        ? ""
                                                                        : values[
                                                                                b
                                                                          ]
                                                                }
                                                                disabled={
                                                                    readOnly
                                                                }
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                            />
                                                            <div className="invalid-feedback">
                                                                {errors &&
                                                                errors[b]
                                                                    ? errors[b]
                                                                    : ""}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );

                                                jobqueueDetailsContent.push(
                                                    addJobqueueField
                                                );
                                            }  
                                                                                                                           
                                            else if (
												b === "id" &&
												filterJobLogList
											) {
												// console.log(typeof filterJobLogList)
												if (
													filterJobLogList.length > 0
												) {
													for (let c in filterJobLogList) {
														for (let d in filterJobLogList[
															c
														]) {
															let forLabel = titleCase(
																d
															).trim();
															// console.log("d",d)
															if (
																d ===
																"message_log"
															) {
																forLabel =
																	"Message";
																let filterJobLogListType =
																	formSchema.hasOwnProperty(
																		b
																	) &&
																	formSchema[
																		b
																	]
																		.jobqueueFieldType &&
																	typeof formSchema[
																		b
																	]
																		.jobqueueFieldType ===
																		"string"
																		? formSchema[
																				b
																		  ]
																				.jobqueueFieldType
																		: "text";

																addJobqueueField = (
																	<div
																		key={
																			keycount++
																		}
																		className="row mb-2"
																		id="transform-input-type"
																	>
																		<div className="col-2 text-left">
																			<label
																				htmlFor={
																					d
																				}
																			>
																				{
																					forLabel
																				}
																			</label>
																		</div>
																		<div className="col-10 text-right">
																			<input
																				className={
																					"form-control" +
																					(errors &&
																					errors[
																						d
																					]
																						? " is-invalid"
																						: "")
																				}
																				type={
																					filterJobLogListType
																				}
																				name={
																					d
																				}
																				id={
																					d
																				}
																				onChange={
																					handleChange
																				}
																				value={
																					filterJobLogList[
																						c
																					][
																						d
																					] ===
																					null
																						? ""
																						: filterJobLogList[
																								c
																						  ][
																								d
																						  ]
																				}
																				disabled={
																					readOnly
																				}
																				data-toggle="tooltip"
																				data-placement="top"
																			/>
																			<div className="invalid-feedback">
																				{errors &&
																				errors[
																					d
																				]
																					? errors[
																							d
																					  ]
																					: ""}
																			</div>
																		</div>
																	</div>
																);
																jobqueueDetailsContent.push(
																	addJobqueueField
																);
															} else if (
																d ===
																"message_arguments"
															) {
																forLabel =
																	"Arguments";
																let filterJobLogListType =
																	formSchema.hasOwnProperty(
																		b
																	) &&
																	formSchema[
																		b
																	]
																		.jobqueueFieldType &&
																	typeof formSchema[
																		b
																	]
																		.jobqueueFieldType ===
																		"string"
																		? formSchema[
																				b
																		  ]
																				.jobqueueFieldType
																		: "text";

																addJobqueueField = (
																	<div
																		key={
																			keycount++
																		}
																		className="row mb-2"
																		id="transform-input-type"
																	>
																		<div className="col-2 text-left">
																			<label
																				htmlFor={
																					d
																				}
																			>
																				{
																					forLabel
																				}
																			</label>
																		</div>
																		<div className="col-10">
																			<JsonViewer
																				value={
																					filterJobLogList[
																						c
																					][
																						d
																					]
																				}
																				name={
																					"data"
																				}
																				collapsed={
																					1
																				}
																			/>
																			{/* <input
                                                                                        className={"form-control" + (errors && errors[d] ? " is-invalid" : "")}
                                                                                        type={"textarea"}
                                                                                        name={d}
                                                                                        id={d}
                                                                                        onChange={handleChange}
                                                                                        value={filterJobLogList[c][d] === null ? "" : filterJobLogList[c][d]}
                                                                                        disabled={readOnly}
                                                                                        data-toggle="tooltip" 
                                                                                        data-placement="top" 
                                                                                    /> */}
																			<div className="invalid-feedback">
																				{errors &&
																				errors[
																					d
																				]
																					? errors[
																							d
																					  ]
																					: ""}
																			</div>
																		</div>
																	</div>
																);
																jobqueueDetailsContent.push(
																	addJobqueueField
																);
															}
														}
													}
												} else if (
													filterJobLogList.length <= 0
												) {
													if (getMemo) {
														let forLabel = titleCase(
															"message"
														).trim();
														addJobqueueField = (
															<div
																key={keycount++}
																className="row mb-2"
																id="transform-input-type"
															>
																<div className="col-2 text-left">
																	<label
																		htmlFor={
																			getMemo
																		}
																	>
																		{
																			forLabel
																		}
																	</label>
																</div>
																<div className="col-10 text-right">
																	<input
																		className={
																			"form-control" +
																			(errors &&
																			errors[
																				getMemo
																			]
																				? " is-invalid"
																				: "")
																		}
																		type={
																			"text"
																		}
																		name={
																			"message-memo"
																		}
																		id={
																			"message-memo"
																		}
																		onChange={
																			handleChange
																		}
																		value={
																			getMemo ===
																			null
																				? ""
																				: getMemo
																		}
																		disabled={
																			readOnly
																		}
																		data-toggle="tooltip"
																		data-placement="top"
																	/>
																	<div className="invalid-feedback">
																		{errors &&
																		errors[
																			getMemo
																		]
																			? errors[
																					getMemo
																			  ]
																			: ""}
																	</div>
																</div>
															</div>
														);
														jobqueueDetailsContent.push(
															addJobqueueField
														);
													}
												}
                                            }
                                            else if (b === "extract_params")   {
                                                addJobqueueField = ( 
                                                    <div
                                                        key={
                                                            keycount++
                                                        }
                                                        className="row mb-2"
                                                        id="transform-input-type"
                                                    >
                                                        <div className="col-2 text-left">
                                                            <label>
                                                                {
                                                                    forLabel
                                                                }
                                                            </label>
                                                        </div>
                                                        <div className="col-10">
                                                            <ReactJson 
                                                                    src={ values[b] === null ? {}: JSON.parse(values[b]) } 
                                                                    theme="bright:inverted"
                                                                    displayDataTypes={false}
                                                                    displayObjectSize={false}
                                                                    collapsed={2}
                                                                    iconStyle={"circle"}
                                                                    enableClipboard={false}
                                                                    name="data"                                                                          
                                                            /> 
                                                        </div>
                                                    </div>
                                                );

                                                jobqueueDetailsContent.push(
                                                    addJobqueueField
                                                );
                                            }   
											// else if (b === "memo" && !filterJobLogList){
											//     forLabel = "Message"
											//     addJobqueueField = (
											//         <div key={keycount++}
											//             className="row mb-2"
											//             id="transform-input-type"
											//         >
											//             {/* <div className="col-12">

											//             </div> */}
											//             <div className="col-2 text-left">
											//             <label htmlFor={b}>
											//                     {forLabel}
											//                 </label>
											//             </div>
											//             <div className="col-10 text-right">
											//                 <input
											//                     className={"form-control" + (errors && errors[b] ? " is-invalid" : "")}
											//                     type={jobqueueFieldType}
											//                     name={b}
											//                     id={b}
											//                     onChange={handleChange}
											//                     value={values[b] === null ? "" : values[b]}
											//                     disabled={readOnly}
											//                     data-toggle="tooltip"
											//                     data-placement="top"
											//                 />
											//                 <div className="invalid-feedback">
											//                     {errors && errors[b] ? errors[b] : ""}
											//                 </div>
											//             </div>
											//         </div>
											//     )
											//     jobqueueDetailsContent.push(addJobqueueField)
											// }

											// if(b === "task_id" || b === "run_datetime" || b === "is_process"){
											//     skipJobqueueField = true
											// }else{

											// }
											// console.log("b",b)
											// console.log("skipJobqueueField",skipJobqueueField)

											// console.log("addJobqueueField",addJobqueueField)
										}

										for (let a in additionalJobqueueTabs) {
											jsonFormTabList.push(
												<NavItem
													active={
														jsonFormCounter === 0
															? "active"
															: ""
													}
													key={`${additionalJobqueueTabs[a]}-${keycount}-tabheader`}
													name={`${additionalJobqueueTabs[a]}-${keycount}`}
													value={
														additionalJobqueueTabs[
															a
														]
													}
													selected={true}
												/>
											);

											jsonFormFields.push(
												<NavContent
													key={`${additionalJobqueueTabs[a]}-${keycount}-tabcontent`}
													id={`${additionalJobqueueTabs[a]}-${keycount}`}
													active={
														jsonFormCounter === 0
															? "show active"
															: ""
													}
													content={
														<div
															key={keycount++}
															className="prop-headers mt-5 mx-5"
														>
															{
																jobqueueDetailsContent
															}
														</div>
													}
												/>
											);
										}
									}

									if (list) {
										let getProviderId;
										let getConnectionId;
										let getDatasourceId;
										let getFrequencyId;
										let hasProvider;
										let hasConnection;
										let hasSchedule;
										let epName;
										let oepName;
										let hasIntegration;
										let checkDatasourceId;
										let checkDatatargetId;
										let checkFrequencyId;

										if (endpointName === "providers") {
											getProviderId = list.id;
											hasProvider = getConnectionList.find(
												(gpl) =>
													gpl.provider_id ===
													getProviderId
											);
										} else if (
											endpointName === "connections"
										) {
											getConnectionId = list.id;
											hasConnection = getDatasourceList.find(
												(gdl) =>
													gdl.connection_id ===
													getConnectionId
											);
										} else if (
											endpointName === "datasources"
										) {
											getDatasourceId = list.id;
											checkDatasourceId = getDatasourcemappingList.find(
												(gdml) =>
													gdml.datasource_id ===
													getDatasourceId
											);
											checkDatatargetId = getDatasourcemappingList.find(
												(gdml) =>
													gdml.datatarget_id ===
													getDatasourceId
											);
											if (
												checkDatasourceId ||
												checkDatatargetId ||
												(checkDatasourceId &&
													checkDatatargetId)
											) {
												hasIntegration = true;
											} else {
												hasIntegration = false;
											}
											epName = "Datasource";
											oepName = "Integration";
										} else if (
											endpointName === "frequencies"
										) {
											getFrequencyId = list.id;
											checkFrequencyId = getScheduleList.find(
												(gsl) =>
													gsl.frequency_id ===
													getFrequencyId
											);
											if (checkFrequencyId) {
												hasSchedule = true;
											} else {
												hasSchedule = false;
											}
											epName = "Frequency";
											oepName = "Schedule";
										}

										// Re-usable panel
										formBtnPanel = (
											<div
												key="btn-panel-top"
												className="add-field-wrapper"
											>
												<div className="absolute-btn">
													<FormButtonPanel
														endpointName={
															endpointName
														}
														key={keycount++}
														isFetching={isFetching}
														formType={formType}
														parentUrl={parentUrl}
														allowDelete={
															isUserAdmin &&
															!readOnly
														}
														allowSave={!readOnly}
														onDelete={() => {
															if (hasProvider) {
																dispatch(
																	showMessage(
																		{
																			type:
																				"error",
																			title:
																				"Delete Message",
																			message:
																				"Unable to delete Provider due to a related Connection.",
																		}
																	)
																);
															} else if (
																hasConnection
															) {
																dispatch(
																	showMessage(
																		{
																			type:
																				"error",
																			title:
																				"Delete Message",
																			message:
																				"Unable to delete Connection due to a related Datasource.",
																		}
																	)
																);
															} else if (
																hasIntegration
															) {
																dispatch(
																	showMessage(
																		{
																			type:
																				"error",
																			title:
																				"Delete Message",
																			message: `Unable to delete ${epName} due to a related ${oepName}. `,
																		}
																	)
																);
															} else if (
																hasSchedule
															) {
																dispatch(
																	showMessage(
																		{
																			type:
																				"error",
																			title:
																				"Delete Message",
																			message: `Unable to delete ${epName} due to a related ${oepName}. `,
																		}
																	)
																);
															} else {																

																if (endpointName == 'users') {

																	if ((list.email == 'super@excelym.com') || (list.email == 'superadmin.io@excelym.com')) {

																		deleteok = false															

																		dispatch(
																			showMessage(
																				{
																					type:
																						"error",
																					title:
																						"Delete Message",
																					message: `Default admin user cannot and should not be deleted. `,
																				}
																			)
																		);
																	} 
																}

																if (deleteok) {
														
																	dispatch(
																		showMessage(
																			{
																				type:
																					"info",
																				title:
																					"Confirmation",
																				message: DEL_MESS,
																				timeout: 0,
																				buttonArray: [
																					"Yes",
																					"No",
																				],
																				onClick: (
																					buttonIndex
																				) => {
																					// If yes button was clicked
																					if (
																						buttonIndex ===
																						0
																					) {
																						dispatch(
																							deleteEndpointList(
																								endpointId,
																								endpointName,
																								list.id,
																								accessToken
																							)
																						).then(
																							(
																								jsonObj
																							) => {
																								if (
																									jsonObj
																										.response
																										.ok &&
																									endpointName !=
																										"users" &&
																									endpointName !=
																										"releasenotes"
																								) {
																									dispatch(
																										showMessage(
																											{
																												type:
																													"success",
																												title:
																													"Deleted",
																												message: `${list.name} has been deleted`,
																												onClick: () => {
																													history.push(
																														parentUrl
																													);
																												},
																											}
																										)
																									);
																								} else if (
																									jsonObj
																										.response
																										.ok &&
																									endpointName ==
																										"users"
																								) {
																									dispatch(
																										showMessage(
																											{
																												type:
																													"success",
																												title:
																													"Deleted",
																												message: `${list.username} has been deleted`,
																												onClick: () => {
																													history.push(
																														parentUrl
																													);
																												},
																											}
																										)
																									);
																								} else if (
																									jsonObj
																										.response
																										.ok &&
																									endpointName ==
																										"releasenotes"
																								) {
																									dispatch(
																										showMessage(
																											{
																												type:
																													"success",
																												title:
																													"Deleted",
																												message: `Version ${list.version} has been deleted`,
																												onClick: () => {
																													history.push(
																														parentUrl
																													);
																												},
																											}
																										)
																									);
																								} else if (
																									!jsonObj
																										.response
																										.ok &&
																									endpointName ==
																										"users"
																								) {																									

																									let error_msg = ''

																									if (jsonObj.response.status == '401') {

																										error_msg = 'Unauthorized user deletion. Cannot delete a superadmin user.'
																									} else {

																										error_msg = 'Internal Server Error'
																									}
																									dispatch(
																										showMessage(
																											{
																												type:
																													"error",
																												title:
																													"Deletion Failed",
																												message: error_msg,
																												onClick: () => {
																													history.push(
																														parentUrl
																													);
																												},
																											}
																										)
																									);
																								}
																							}
																						);
																					}
																				},
																			}
																		)
																	);
																}
															}
														}}
													/>
												</div>
											</div>
										);

										if (endpointName === "connections") {
											formBtnPanel = (
												<div
													key="btn-panel-top"
													className="add-field-wrapper"
												>
													<div className="absolute-btn">
														<FormButtonPanel
															endpointName={
																endpointName
															}
															key={keycount++}
															isFetching={
																isFetching
															}
															formType={formType}
															parentUrl={
																parentUrl
															}
															allowDelete={
																isUserAdmin &&
																!readOnly
															}
															allowSave={
																isUserAdmin &&
																!readOnly
															}
															onDelete={() => {
																if (
																	hasProvider
																) {
																	dispatch(
																		showMessage(
																			{
																				type:
																					"error",
																				title:
																					"Delete Message",
																				message:
																					"Unable to delete Provider due to a related Connection.",
																			}
																		)
																	);
																} else if (
																	hasConnection
																) {
																	dispatch(
																		showMessage(
																			{
																				type:
																					"error",
																				title:
																					"Delete Message",
																				message:
																					"Unable to delete Connection due to a related Datasource.",
																			}
																		)
																	);
																} else {
																	dispatch(
																		showMessage(
																			{
																				type:
																					"info",
																				title:
																					"Confirmation",
																				message: DEL_MESS,
																				timeout: 0,
																				buttonArray: [
																					"Yes",
																					"No",
																				],
																				onClick: (
																					buttonIndex
																				) => {
																					// If yes button was clicked
																					if (
																						buttonIndex ===
																						0
																					) {
																						dispatch(
																							deleteEndpointList(
																								endpointId,
																								endpointName,
																								list.id,
																								accessToken
																							)
																						).then(
																							(
																								jsonObj
																							) => {
																								if (
																									jsonObj
																										.response
																										.ok &&
																									endpointName !=
																										"users"
																								) {
																									dispatch(
																										showMessage(
																											{
																												type:
																													"success",
																												title:
																													"Deleted",
																												message: `${list.name} has been deleted`,
																												onClick: () => {
																													history.push(
																														parentUrl
																													);
																												},
																											}
																										)
																									);
																								} else if (
																									jsonObj
																										.response
																										.ok &&
																									endpointName ==
																										"users"
																								) {
																									dispatch(
																										showMessage(
																											{
																												type:
																													"success",
																												title:
																													"Deleted",
																												message: `${list.username} has been deleted`,
																												onClick: () => {
																													history.push(
																														parentUrl
																													);
																												},
																											}
																										)
																									);
																								}
																							}
																						);
																					}
																				},
																			}
																		)
																	);
																}
															}}
															onTestConnection={() => {
																let connId =
																	list.id;
																let connName =
																	list.name;
																dispatch(
																	setLoader(
																		true
																	)
																);
																fetch(
																	`${REST_API}/connections/test/${connId}?access_token=${accessToken}`,
																	{
																		// fetch(`${REST_API}/connections/test/${connId}?`,{
																		method:
																			"GET",
																		headers: {
																			"Content-Type":
																				"application/json",
																		},
																	}
																)
																	.then(
																		(
																			response
																		) => {
																			return response.json();
																		}
																	)
																	.then(
																		(
																			json
																		) => {
																			/*console.log(
																				"jsonjson",
																				json
																			);*/

																			if (
																				json.success
																			) {
																				dispatch(
																					setLoader(
																						false
																					)
																				);
																				dispatch(
																					showMessage(
																						{
																							type:
																								"success",
																							title:
																								"Success",
																							message: `Connection Successful.`,
																						}
																					)
																				);
																			} else {
																				dispatch(
																					setLoader(
																						false
																					)
																				);
																				dispatch(
																					showMessage(
																						{
																							type:
																								"error",
																							title:
																								"Error",
																							message:
																								json
																									.error
																									.message,
																						}
																					)
																				);
																			}
																		}
																	)
																	.catch(
																		(
																			error
																		) => {
																			if (
																				error
																			) {
																				dispatch(
																					setLoader(
																						false
																					)
																				);
																				dispatch(
																					showMessage(
																						{
																							type:
																								"error",
																							title:
																								"",
																							message: `Connection Failed.`,
																						}
																					)
																				);
																			}
																		}
																	);
															}}
														/>
													</div>
												</div>
											);
										}

										for (var n in list) {
											let forLabel = titleCase(n).trim();
											forLabel =
												forLabel ===
												"Published Duration"
													? "Published Duration (in seconds)"
													: forLabel;
											let ntyp = null;
											let propObj = {};
											let nobj = null;

											// If a schema was set (to specify password fields)
											// Try to get the fieldType for the field, else default to "text"
											let fieldType =
												formSchema.hasOwnProperty(n) &&
												formSchema[n].fieldType &&
												typeof formSchema[n]
													.fieldType === "string"
													? formSchema[n].fieldType
													: "text";

											try {
												nobj = JSON.parse(list[n]);
												ntyp = typeof nobj;
												propObj.property = n;
											} catch (e) {
												ntyp = "string";
											}
											// console.log("list[n]",list[n])
											// store the 'status' field on a separate variable, since this should be first
											if (
												(ntyp === "string" ||
													ntyp === "number") &&
												n === "status"
											) {
												let allowActivate = true;
												let activateError =
													"You cannot activate at this time";
												if (
													endpointName === "schedules"
												) {
													let taskEndpoint = endpoints.find(
														(endP) =>
															endP.name ===
															"tasks"
													);
													let associatedTask = taskEndpoint.list.find(
														(task) =>
															task.id ===
															list.task_id
													);
													if (
														associatedTask &&
														associatedTask.status ===
															0
													) {
														let sbLabel = sidebars.find(
															(sidebar) =>
																sidebar.endpointId ===
																1
														).label;
														sbLabel = sbLabel.toLowerCase();
														let integrationLink = `/${sbLabel}/${associatedTask.id}`;

														allowActivate = false;
														activateError = (
															<p>
																You cannot
																activate a
																schedule for an
																inactive
																integration.
																Please activate
																the integration
																first <br />
																<a
																	href={
																		integrationLink
																	}
																	onClick={(
																		e
																	) => {
																		e.preventDefault();
																		dispatch(
																			closeMessage()
																		);
																		history.push(
																			integrationLink
																		);
																		return false;
																	}}
																>
																	Go to
																	integration
																	page
																</a>
															</p>
														);
													}
												}

												statusField = endpointName !==
													"providers" && (
													<div
														key={keycount++}
														className="prop-header"
													>
														<div
															key={keycount++}
															className="col-12 mt-3"
															id="transform-input-type"
														>
															<div className="col-12">
																<label
																	htmlFor={n}
																>
																	{n ===
																	"status"
																		? "Active"
																		: forLabel}
																	{requiredFields.includes(
																		n
																	)
																		? "*"
																		: ""}
																</label>
															</div>
															<div
																className="col-12"
																style={{
																	fontSize:
																		"0.75rem",
																}}
															>
																{!readOnly ? (
																	<Statuspick
																		id={n}
																		name={n}
																		className="form-control"
																		onChange={
																			handleChange
																		}
																		defaultChecked={
																			values.status ===
																			1
																		}
																		showText={
																			true
																		}
																		status={
																			values.status
																		}
																		allowActivate={
																			allowActivate
																		}
																		activateError={
																			activateError
																		}
																		endpoints={
																			endpoints
																		}
																		endpointName={
																			endpointName
																		}
																		endpointId={
																			values.id
																		}
																		connectionName={
																			values.name
																		}
																	/>
																) : values.status ? (
																	"Yes"
																) : (
																	"No"
																)}
																<div className="invalid-feedback">
																	{errors &&
																	errors[n]
																		? errors[
																				n
																		  ]
																		: ""}
																</div>
															</div>
														</div>
													</div>
												);
											} else if (
												ntyp === "string" ||
												ntyp === "number" ||
												nobj === null ||
												ntyp === "boolean"
											) {
												let skipField = false;
												let fieldIsDate = false;

												let isTypeTime = false;
												let isTypeDate = false;
												let isQueue_no = false;
												let isReadyOnly = false;
												let isUserAdminOnly = false;

												if (
													n === "created_at" ||
													n === "updated_at" ||
													n === "created" ||
													n === "modified"
												) {
													values[n] = moment(
														values[n]
													).format(
														"YYYY-MM-DD HH:mm:ss"
													);
													isReadyOnly = true;
												} else if (
													(n === "created_by" &&
														!values[n]) ||
													(n === "updated_by" &&
														!values[n])
												) {
													values[n] = "Cron";
												} else if (
													n === "release_date"
												) {
													values[n] === "Invalid date"
														? (values[
																n
														  ] = moment().format(
																"YYYY-MM-DD"
														  ))
														: (values[n] = moment(
																values[n]
														  ).format(
																"YYYY-MM-DD"
														  ));
													fieldIsDate = true;
												}

												if (
													moment(
														values[n],
														"YYYY-MM-DD HH:mm:ss",
														true
													).isValid()
												) {
													fieldIsDate = true;
												}
												/* else if ( moment(values[n],'HH:mm:ss',true).isValid() ){
                                                fieldIsTime = true
                                            } */

												if (
													n === "id" ||
													n === "status" || // Skip status here since this is rendered on a separate variable
													(endpointName ===
														"connections" &&
														n === "type")
												) {
													skipField = true;
												}

												if (
													endpointName === "jobqueues"
												) {
													if (
														n === "status" ||
														n === "ref_id" ||
														n === "memo" ||
														n ===
															"process_status" ||
														n ===
															"process_start_at" ||
														n ===
															"process_end_at" ||
														n === "queue_no" ||
														n === "updated_by" ||
														n === "updated_at" ||
														n === "created_by" ||
														n === "created_at"
													) {
														skipField = true;
													}

													if (n === "task_id") {
														isReadyOnly = true;
													}
												}
												if (
													endpointName === "messagequeues"
												) {

													if (n === "task_id") {
														isReadyOnly = true;
													}
												}
												if (
													endpointName === "schedules"
												) {

													if (n === "task_id") {
														isReadyOnly = true;
													}
												}

												if (
													n === "updated_by" ||
													n === "updated_at" ||
													n === "created_by" ||
													n === "created_at" ||
													n === "modified" ||
													n === "created"
												) {
													isReadyOnly = true;
												}												

												if (n === "start_date") {
													isTypeTime = true;
												}

												if (n === "queue_no") {
													isQueue_no = true;
												}

												if (endpointName === "users") {
													if (
														n === "realm" ||
														n === "emailVerified"
													) {
														skipField = true;
													}

													if (
														n === "email"
													) {
														isReadyOnly = true;
													}
												}

												if (endpointName === "frequencies") {

													if ((n === "code") && (list.id)) {
														isReadyOnly = true;
													}
												}

												//Convert userid to username to view
												let userEndpoint = endpoints.find(
													(userEndP) =>
														userEndP.name ===
														"users"
												);
												let associatedUpdateUser = userEndpoint.list.find(
													(uUser) =>
														uUser.id ===
														list.updated_by
												);
												let associatedCreateUser = userEndpoint.list.find(
													(cUser) =>
														cUser.id ===
														list.created_by
												);

												let getAssociatedUpdateUserName =
													associatedUpdateUser &&
													associatedUpdateUser.username;
												let getAssociatedCreateUserName =
													associatedCreateUser &&
													associatedCreateUser.username;
												let getAssociatedUpdateId =
													associatedUpdateUser &&
													associatedUpdateUser.id;
												let getAssociatedCreateId =
													associatedCreateUser &&
													associatedCreateUser.id;

												getAssociatedUpdateUserName
													? (values.updated_by = getAssociatedUpdateUserName)
													: getAssociatedUpdateId;
												getAssociatedCreateUserName
													? (values.created_by = getAssociatedCreateUserName)
													: getAssociatedCreateId;

												let addField = !skipField && (
													<div
														key={keycount++}
														className="col-12 mt-3"
														id="transform-input-type"
													>
														<div className="col-12">
															<label htmlFor={n}>
																{n === "status"
																	? "Active"
																	: forLabel}
																{requiredFields.includes(
																	n
																)
																	? "*"
																	: ""}
															</label>
														</div>				
														<div className="col-12">
															{fieldIsDate ? (
																isReadyOnly ? (
																	// <Datepick
																	// 	className={
																	// 		"form-control" +
																	// 		(errors &&
																	// 		errors[
																	// 			n
																	// 		]
																	// 			? " is-invalid"
																	// 			: "")
																	// 	}
																	// 	type={
																	// 		fieldType
																	// 	}
																	// 	name={n}
																	// 	id={n}
																	// 	onChange={
																	// 		handleChange
																	// 	}
																	// 	selected={
																	// 		// Date.parse(values[n] )
																	// 		values[n] ? values[n].split(" ")[0] : ""
																	// 		// ===
																	// 		// null
																	// 		// 	? moment().format(
																	// 		// 			"YYYY-MM-DD"
																	// 		// 	  )
																	// 		// 	: values[
																	// 		// 			n
																	// 		// 	  ]
																	// 	}
																	// 	disabled={
																	// 		true
																	// 	}
																	// 	dateFormat="MM-DD-YYYY HH:mm:ss"
																	// 	error={
																	// 		errors &&
																	// 		errors[
																	// 			n
																	// 		]
																	// 			? errors[
																	// 					n
																	// 			  ]
																	// 			: ""
																	// 	}
																	// />
																	<label>{values[n] ? values[n].split(" ")[0] : ""}</label>
																) : (
																	<Datepick
																		className={
																			"form-control" +
																			(errors &&
																			errors[
																				n
																			]
																				? " is-invalid"
																				: "")
																		}
																		type={
																			fieldType
																		}
																		name={n}
																		id={n}
																		onChange={
																			handleChange
																		}
																		selected={
																			// Date.parse(values[n] )
																			values[n] ? values[n].split(" ")[0] : ""
																			//  ===
																			// null
																			// 	? moment().format(
																			// 			"YYYY-MM-DD"
																			// 	  )
																			// 	: values[
																			// 			n
																			// 	  ]
																		}
																		disabled={
																			readOnly
																		}
																		dateFormat={
																			n ===
																			"release_date"
																				? "MM-DD-YYYY"
																				: "MM-DD-YYYY HH:mm:ss"
																		}
																		error={
																			errors &&
																			errors[
																				n
																			]
																				? errors[
																						n
																				  ]
																				: ""
																		}
																	/>
																)
															) : isQueue_no ? (
																<QueueDropdown
																	id={n}
																	name={n}
																	endpointName="queue_no"
																	className={
																		"form-control" +
																		(errors &&
																		errors[
																			n
																		]
																			? " is-invalid"
																			: "")
																	}
																	value={
																		values[
																			n
																		]
																	}
																	onChange={
																		handleChange
																	}
																/>
															) : isReadyOnly ? 
																( 
																  (n == 'email' && !values['id']) ? (
																  	<input
																		className={
																			"form-control" +
																			(errors &&
																			errors[
																				n
																			]
																				? " is-invalid"
																				: "")
																		}
																		type={
																			fieldType
																		}
																		name={n}
																		id={n}
																		onChange={
																			handleChange
																		}
																		value={
																			values[
																				n
																			] ===
																			null
																				? ""
																				: values[
																						n
																				]
																		}
																		disabled={
																			readOnly
																		}
																		data-toggle="tooltip"
																		data-placement="top"
																		title={
																			n ===
																			"memo"
																				? values[
																						n
																				]
																				: ""
																		}
																	/>
																  ): 
																  ['updated_by', 'created_by', 'email'].includes(n) ? 
																	(
																		<label> {
																			values[
																				n
																			] ===
																			null
																				? ""
																				: values[
																						n
																				]
																			}
																		</label>
																	) : (
																		<input
																			readOnly
																			className={
																				"form-control" +
																				(errors &&
																				errors[
																					n
																				]
																					? " is-invalid"
																					: "")
																			}
																			type={
																				fieldType
																			}
																			name={n}
																			id={n}
																			onChange={
																				handleChange
																			}
																			value={
																				values[
																					n
																				] ===
																				null
																					? ""
																					: values[
																							n
																					]
																			}
																			disabled={
																				readOnly
																			}
																			data-toggle="tooltip"
																			data-placement="top"
																			title={
																				n ===
																				"memo"
																					? values[
																							n
																					]
																					: ""
																			}
																		/>
																	)
																) : (
																	<input
																		className={
																			"form-control" +
																			(errors &&
																			errors[
																				n
																			]
																				? " is-invalid"
																				: "")
																		}
																		type={
																			fieldType
																		}
																		name={n}
																		id={n}
																		onChange={
																			handleChange
																		}
																		value={
																			values[
																				n
																			] ===
																			null
																				? ""
																				: values[
																						n
																				]
																		}
																		disabled={
																			readOnly
																		}
																		data-toggle="tooltip"
																		data-placement="top"
																		title={
																			n ===
																			"memo"
																				? values[
																						n
																				]
																				: ""
																		}
																	/>
																)}
															<div className="invalid-feedback">
																{errors &&
																errors[n]
																	? errors[n]
																	: ""}
															</div>
														</div>
													</div>
												);

												{
													/* <input
                                                                    readOnly
                                                                    className={"form-control" + (errors && errors[n] ? " is-invalid" : "")}
                                                                    type={fieldType}
                                                                    name={n}
                                                                    id={n}
                                                                    onChange={handleChange}
                                                                    value={values[n] === null ? "" : values[n]}
                                                                    disabled={readOnly}
                                                                /> */
                        }

                        // Added to show a dropdown on the main properties.
                        if (n.includes("_id") && !forcePlainText.includes(n)) {
                          let keyArr = n.split("_id");
                          let referencedEndpointName = keyArr[0].match(/y$/)
                            ? n.replace("y_id", "ies")
                            : n.replace("_id", "s");
                          referencedEndpointName = referencedEndpointName.toLowerCase();

                          fields.push(
                            <div className="prop-header" key={keycount++}>
                              <div
                                className="col-12 mt-3"
                                id="transform-input-type"
                              >
                                <div className="col-12">
                                  <label htmlFor={n}>
                                    {forLabel}
                                    {requiredFields.includes(n) ? "*" : ""}
                                  </label>
                                </div>
                                <div className="col-12">
                                  <ReferenceDropdown
                                    taskId={values.task_id}
                                    valueName={values.name}
                                    value={values[n]}
                                    onChange={handleChange}
                                    endpointName={referencedEndpointName}
                                    className={
                                      "form-control" +
                                      (errors && errors[n] ? " is-invalid" : "")
                                    }
                                    name={n}
                                    id={n}
                                    disabled={readOnly}
                                    showInactive={false}
                                    fallBackToText={false}
                                    //disabled={!isUserAdmin? true:false}
                                    disabled={isReadyOnly}
                                  />
                                  <div className="invalid-feedback">
                                    {errors && errors[n] ? errors[n] : ""}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        } else if (n === "notes") {
                          jsonFormFields.push(
                            <div
                              className="prop-header-textarea"
                              key={keycount++}
                            >
                              <div
                                className="col-12 mt-3"
                                id="transform-input-type"
                              >
                                <div className="col-12">
                                  <label htmlFor={n}>
                                    {forLabel}
                                    {requiredFields.includes(n) ? "*" : ""}
                                  </label>
                                </div>
                                <div className="col-12">
                                  <ReactQuill
                                    value={values[n]}
                                    modules={modules}
                                    onChange={value =>
                                      setFieldValue("notes", value)
                                    }
                                    theme={"snow"}
                                    placeholder={"Add Changelog"}
                                  />

                                  {/* <textarea className="form-control" name={n} id={n} rows="10" onChange={handleChange} defaultValue={values[n]}></textarea>
                                   */}

                                  <div className="invalid-feedback">
                                    {errors && errors[n] ? errors[n] : ""}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        } else if ((endpointName === "schedules") && (n === "start_time")) {

            				fields.push(<div key={n} className="prop-header">
            					<div class="col-12 mt-3" id="transform-input-type">
	            					<div class="col-12">
				                        <label htmlFor={`schedule.start_time`}>Start Time</label>
				                        <Timepick
				                            id={`schedule.start_time`}
				                            name={`start_time`}
				                            selected={values[n]}
				                            onChange={handleChange}
				                            className={"form-control" + (errors && errors["start_time"] ? " is-invalid" : "")}
				                            error={errors && errors["start_time"] ? errors["start_time"] : ""}
				                        />      
				                    </div>
				                </div>                
		                    </div>)

                        } else if ((endpointName === "schedules") && (n === "end_time")) {

            				fields.push(<div key={n} className="prop-header">
            					<div class="col-12 mt-3" id="transform-input-type">
	            					<div class="col-12">
				                        <label htmlFor={`schedule.end_time`}>End Time</label>
				                        <Timepick
				                            id={`schedule.end_time`}
				                            name={`end_time`}
				                            selected={values[n]}
				                            onChange={handleChange}
				                            className={"form-control" + (errors && errors["end_time"] ? " is-invalid" : "")}
				                            error={errors && errors["end_time"] ? errors["end_time"] : ""}
				                        />      
				                    </div>
				                </div>                
		                    </div>)

                        } else {
                          //remove Name and Description and TOPIC
                          if (endpointName === "messagequeues") {
							  var fldsArrMQ = ["name", "description", "audit", "remarks", "topic", "update_flag", "message", "last_modified_date", "last_modified_value", "last_error_date","is_error_retry"]
                            if (fldsArrMQ.indexOf(n) != -1) {
                            } else {
                              fields.push(
                                <div key={keycount++} className="prop-header">
                                  {addField}
                                </div>
                              );
                            }

                          }else if(endpointName == 'jobqueues'){
							if (
								n === "extract_params" 
							  ) {
							  } else {
								fields.push(
								  <div key={keycount++} className="prop-header">
									{addField}
								  </div>
								);
							  }
						  }
						   else {
                            fields.push(
                              <div key={keycount++} className="prop-header">
                                {addField}
                              </div>
                            );
                          }
                        }
                      } else {
                        let renderView = null;
                        let allowedTypes = ["Text", "Password"];
                        let ignoreFields = ["options", "datasource"];
                        let ignoredEndpoint = ["providers", "datasources"];

                        // console.log("values[n]",values[n])
                        // console.log("values",values)

                        // console.log('forLabel',forLabel)

                        if (forLabel === "Message") {
                          forLabel = "Transformed ";
                        } else if (forLabel === "Message Raw") {
                          forLabel = "Extracted";
                        }

                        // Remove object datatype on JSONForm for connections and datasources
                        if (
                          endpointName === "connections" ||
                          endpointName === "datasources"
                        ) {
                          allowedTypes.push("Date");
                        }                       

                        if (endpointName === "messagequeues") {
                          renderView = (
                            <JsonViewer value={values[n]} name={"data"} />
                          );
                        } else if (
                          endpointName === "releasenote" &&
                          n === "release_date"
                        ) {
                          renderView = (
                            <textarea
                              class="form-control"
                              id="exampleFormControlTextarea1"
                              rows="3"
                            ></textarea>
                          );
                          // }
                        } else if (endpointName === "connections") {

                        	let data = JSON.parse(values[n])

                        	if (initVal["connection"] == values[n]) {

		                  		if (data) {

			                  		let meta = data.meta
			                  		
			                  		if(meta) {

			                  			for (let k in meta) {

			                  				if (meta[k].type == 'password') {

			                  					data[k] = ""
			                  				}
			                  			}

			                  			values[n] = JSON.stringify(data)
			                  		}
			                  	}
			                 }

		                  	let hideForm = false

                        	if (                        	

	                        	(parseInt(values["id"])) &&

	                        	(initVal["connection"] != "{}")  
	                        ) {

	                        	hideForm = true
	                        }
	                        	
	                        renderView = (
	                            <JSONForm
	                              type="text"                              
	                              name={n}
	                              id={n}
	                              onChange={handleChange}
	                              value={values[n]}
	                              label={list.name}
	                              allowedTypes={allowedTypes}
	                              endpointFrom={endpointName}
	                              dispatch={dispatch}
	                              isUserAdmin={isUserAdmin}
	                              hideForm={hideForm}
	                            />
	                        );
                        } else {
                          renderView = (
                            <JSONForm
                              type="text"                              
                              name={n}
                              id={n}
                              onChange={handleChange}
                              value={values[n]}
                              label={list.name}
                              allowedTypes={allowedTypes}
                              endpointFrom={endpointName}
                              dispatch={dispatch}
                              isUserAdmin={isUserAdmin}
                            />
                          );
                        }

                        //HERE for Messagequeuetab
                        // console.log("forLabel",forLabel)

                        // console.log("isUserAdmin",isUserAdmin)

                        // console.log("n",n)

                        // console.log("endpointName",endpointName)

                        let checkIgnoredTab = ignoreFields.find(igf => igf == n)
                          ? true
                          : false;
                        // console.log("checkIgnoredTab",checkIgnoredTab)
                        let checkIgnoredEndpoint = ignoredEndpoint.find(
                          ige => ige == endpointName
                        )
                          ? true
                          : false;

                        if (
                          (checkIgnoredTab &&
                            endpointName === "providers" &&
                            isUserAdmin) ||
                          (checkIgnoredTab &&
                            endpointName === "datasources" &&
                            isUserAdmin)
                        ) {
                          jsonFormFields.push(
                            <NavContent
                              key={`${n}-${keycount}-tabcontent`}
                              id={`${n}-${keycount}`}
                              active={
                                jsonFormCounter === 0 ? "show active" : ""
                              }
                              content={<div className="p-2">{renderView}</div>}
                            />
                          );

                          jsonFormTabList.push(
                            <NavItem
                              active={jsonFormCounter === 0 ? "active" : ""}
                              key={`${n}-${keycount}-tabheader`}
                              name={`${n}-${keycount}`}
                              value={forLabel}
                              selected={jsonFormCounter === 0}
                            />
                          );
                        } else if (
                         // endpointName === "connections" ||
                          endpointName === "messagequeues"
                        ) {
                          jsonFormFields.push(
                            <NavContent
                              key={`${n}-${keycount}-tabcontent`}
                              id={`${n}-${keycount}`}
                              active={
                                jsonFormCounter === 0 ? "show active" : ""
                              }
                              content={<div className="p-2">{renderView}</div>}
                            />
                          );

                          jsonFormTabList.push(
                            <NavItem
                              active={jsonFormCounter === 0 ? "active" : ""}
                              key={`${n}-${keycount}-tabheader`}
                              name={`${n}-${keycount}`}
                              value={forLabel}
                              selected={jsonFormCounter === 0}
                            />
                          );
                        } else if (
                          endpointName === "connections"
                        ) {

                          	let resetBtn = ""

                          	if (
	                        	(endpointName === "connections") &&

	                        	(parseInt(values["id"])) &&

	                        	(initVal["connection"] != "{}")  
	                        ) {

	                      		resetBtn = (
		                          	<button 
							            type="button" 
							            id="connection_reset_btn"
							            className="btn btn-warning btn-sm align-self-end"
							            onClick={()=>{

						                  	document.getElementById("JSONForm_connection").style.visibility = "visible";	
						                  	document.getElementById("connection_reset_btn").style.display = "none";
							            }}
							        >
							        	Reset
							        </button>
		                        )  
		                    }                          

                          jsonFormFields.push(
                            <NavContent
                              key={`${n}-${keycount}-tabcontent`}
                              id={`${n}-${keycount}`}
                              active={
                                jsonFormCounter === 0 ? "show active" : ""
                              }
                              content={<div className="p-2">{resetBtn}{renderView}</div>}
                            />
                          );

                          jsonFormTabList.push(
                            <NavItem
                              active={jsonFormCounter === 0 ? "active" : ""}
                              key={`${n}-${keycount}-tabheader`}
                              name={`${n}-${keycount}`}
                              value={forLabel}
                              selected={jsonFormCounter === 0}
                            />
                          );
                        }

                        if (
                          (endpointName === "providers" && isUserAdmin) ||
                          (endpointName === "connections" && isUserAdmin) ||
                          (endpointName === "datasources" && isUserAdmin)
                        ) {
                          let epName;
                          if (endpointName == "providers") {
                            epName = "provider";
                          } else if (endpointName === "connections") {
                            epName = "connection";
                          } else if (endpointName === "datasources") {
                            epName = "datasource";
                          }
                          let filterAuditList = getAuditList.filter(
                            fal =>
                              fal.document_id === list.id &&
                              fal.document_type === epName
                          );

                          for (let a in additionalTabs) {
                            jsonFormTabList.push(
                              <NavItem
                                key={`${additionalTabs[a]}-${keycount}-tabheader`}
                                name={`${additionalTabs[a]}-${keycount}`}
                                value={additionalTabs[a]}
                              />
                            );

                            jsonFormFields.push(
                              <NavContent
                                key={`${additionalTabs[a]}-${keycount}-tabcontent`}
                                id={`${additionalTabs[a]}-${keycount}`}
                                content={
                                  <div className="p-2">
                                    <JsonTableViewer
                                      value={filterAuditList}
                                      user={getUserList}
                                    />
                                  </div>
                                }
                              />
                            );
                          }
                        }

                        jsonFormCounter++;
                        keycount++;
                      }
                    }
                  }

                  return (
                    <div className="form-area-wrapper">
                      <form className="form-area-form " onSubmit={onHandleSubmit}>
                        {formBtnPanel}
                        <div className="endpoint-main-pane">
                          {statusField}
                          {fields}
                        </div>
                        <div className="endpoint-details-pane">
                          <div className="json-data-wrapper">
                            <div className="json-data-header">
                              <ul
                                className="nav nav-tabs"
                                id="json-tab"
                                role="tablist"
                              >
                                {jsonFormTabList}
                              </ul>
                            </div>
                            <div
                              className="tab-content margined"
                              id="generic-tab-content"
                            >
                              {jsonFormFields}
                            </div>
                          </div>
                        </div>
                      </form>
                      {isLoading && (
                        <div className="integration-form-overlay">
                          <div className="integration-form-overlay-icon">
                            <i className="fa fa-circle-notch integration fa-spin fa-lg"></i>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                }}
              ></Formik>
            )}
          </div>
        </div>
      )}
    </CSSTransition>
  );
};

function titleCase(str) {
	//return str.replace(('_' || '-' || ' _' || '_ ' || '.'), ' ' || '_id', 'id')
	return str
		.replace(/(_ )|( _)|[_.-]/g, " " || "_id", "id")
		.toLowerCase()
		.split(" " || "_")
		.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
		.join(" ")
		.replace("Id", "");
}

async function fetchId(lid, endpointName, token) {

	//console.log('lid: ', lid)
	//console.log('endpointName: ', endpointName)
	//console.log('token: ', token)

	if (!lid) {
		
		return false
	}
	let test = await fetch(
		`${REST_API}/${endpointName}/${lid}?access_token=${token}`,
		{
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				"Access-Control-Allow-Origin": "*",
			},
		}
	)
		.then((response) => {
			return response.json();
		})
		.then((json) => {
			return json;
		});

	getFetched = test;
}

function mapStateToProps(state, ownProps) {

	//console.log('getFetched: ', getFetched)
	//console.log('statesadasd',state.loader.loading)
	
	let lid = ownProps.match.params.id;
	let epl = ownProps.endpoint.list;
	let editList = epl.find((l) => l.id === Number(lid));
	// delete editList.description
	let list = ownProps.formType === "edit" ? editList : ownProps.endpoint.form;

	let formSchema = ownProps.endpoint.formSchema || {};
	// let showBtn = ownProps.endpoint.sidebar

	let isUserAdmin = state.auth.user && state.auth.user.isAdmin;

	//if (ownProps.endpoint.isFetching) {

	//fetchId(lid, ownProps.endpoint.name, state.auth.access_token);
	//}

	return {
		isLoading: state.loader.loading,
		list: list,
		lid: lid,
		endpointId: ownProps.endpoint.id,
		endpointName: ownProps.endpoint.name,
		accessToken: state.auth.access_token,
		endpoints: state.endpoints,
		isFetching: ownProps.endpoint.isFetching,
		formType: ownProps.formType,
		parentUrl: ownProps.parentUrl,
		formSchema: formSchema,
		isUserAdmin: isUserAdmin,
		readOnly: ownProps.readOnly,
		deleteok : true
		// showBtn: showBtn
	};
}
export default withRouter(connect(mapStateToProps)(EndpointForm));
//  export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EndpointForm))



// WEBPACK FOOTER //
// ./src/components/endpointForm.js